// extracted by mini-css-extract-plugin
export default {"input":"Registration_input__hZ4xc","inputError":"Registration_inputError__j87N5","inputSuccess":"Registration_inputSuccess__6pqkI","word":"Registration_word__Kkbuf"};